
const contactForm = {
  'contactMe.header': 'Ich kann nicht warten, kontaktiere mich!',
  'contactMe.instructions': 'Bitte füllen Sie das untenstehende Formular aus, damit unsere Vertreter sich mit Ihnen in Verbindung setzen können.',
  'contactMe.name': 'Name',
  'contactMe.lastName': 'Nachname',
  'contactMe.email': 'E-Mail (optional)',
  'contactMe.country': 'Land',
  'contactMe.whatsappNumber': 'WhatsApp-Nummer',
  'contactMe.countryCode': 'Ländercode',
  'contactMe.language': 'Bevorzugte Sprache',
  'contactMe.message': 'Nachricht (optional)',
  'contactMe.submit': 'Senden',
  'contactMe.submitting': 'Wird gesendet...',
  'contactMe.success.title': 'Vielen Dank für Ihre Kontaktaufnahme!',
  'contactMe.success.message': 'Ihre Informationen wurden erfolgreich übermittelt. Ein Vertreter von The Club wird sich in Kürze mit Ihnen in Verbindung setzen.',
  'contactMe.placeholders.name': 'Geben Sie Ihren Namen ein',
  'contactMe.placeholders.lastName': 'Geben Sie Ihren Nachnamen ein',
  'contactMe.placeholders.email': 'Geben Sie Ihre E-Mail ein',
  'contactMe.placeholders.country': 'Wählen Sie Ihr Land',
  'contactMe.placeholders.countryCode': 'Code',
  'contactMe.placeholders.whatsappNumber': 'WhatsApp-Nummer',
  'contactMe.placeholders.language': 'Wählen Sie Ihre bevorzugte Sprache',
  'contactMe.placeholders.message': 'Schreiben Sie hier Ihre Nachricht',
  'contactMe.errors.name': 'Name ist erforderlich',
  'contactMe.errors.lastName': 'Nachname ist erforderlich',
  'contactMe.errors.email': 'Ungültige E-Mail-Adresse',
  'contactMe.errors.country': 'Land ist erforderlich',
  'contactMe.errors.countryCode': 'Ländercode ist erforderlich',
  'contactMe.errors.whatsappNumber': 'WhatsApp-Nummer ist erforderlich',
  'contactMe.errors.language': 'Sprache ist erforderlich',
  'contactMe.errors.messageMaxLength': 'Die Nachricht darf nicht mehr als {max} Zeichen enthalten',
  'contactMe.errors.submission': 'Formularübermittlung fehlgeschlagen',
  'contactMe.errors.generic': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
  'contactMe.page.title': 'Beginnen Sie zu Verdienen Bevor Alle Anderen',
};

export default contactForm;
